import React from "react";
import ResourceUpload from "../Components/ResourceUpload";
function About() {
    return (
        <div>
            <ResourceUpload />
        </div>
    );
}

export default About;
